export const getTrackingUserId = (getters) => {
	const {applicationUserLoggedIn, customerDetails} = getters;
	const userTrackingUserId = ((customerDetails || {}).meta || {}).helloRetailTrackingUserId;
	return applicationUserLoggedIn ? userTrackingUserId : localStorage.getItem("helloRetail_trackingUserId_guest");
};